interface ICorretora {
  id: string;
  apelido: string;
  nome: string;
  passos?: string[];
  cor: string;
  leitorBMF?: boolean;
  leitorBovespa?: boolean;
  avatar?: string;
}

export default class Corretora implements ICorretora {
  public id!: string;
  public apelido!: string;
  public nome!: string;
  public passos?: string[];
  public cor!: string;
  public leitorBMF?: boolean;
  public leitorBovespa?: boolean;
  public avatar?: string;
  constructor(param: ICorretora) {
    Object.assign(this, param);
  }
}
